module.exports = __webpack_public_path__ + "static/media/Join the Future of Smart Retail - bulld with Frovo.7400afbe.png";